export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11986.1fa5ae89.jpg";